import { Arrow } from '@fs/zion-icon'
import React, { type CSSProperties } from 'react'
import { HeightDiv } from './providers/HeightProvider'
import MergeSquareCardMarginBoxY from './layout/MergeSquareCardMarginBoxY'
import SeparatorBorder from './layout/SeparatorBorder'

type Props = {
  style?: CSSProperties
}

export default function OneMergePageArrow({ style }: Props): JSX.Element {
  return (
    <SeparatorBorder>
      <MergeSquareCardMarginBoxY>
        <div style={{ padding: '0 2px', ...style }}>
          <HeightDiv centerContents id="person-header" type="compare4" skipDelay>
            <Arrow />
          </HeightDiv>
        </div>
      </MergeSquareCardMarginBoxY>
    </SeparatorBorder>
  )
}
